import { render, staticRenderFns } from "./TrainingMaterials.vue?vue&type=template&id=02328887&scoped=true"
import script from "./TrainingMaterials.vue?vue&type=script&lang=js"
export * from "./TrainingMaterials.vue?vue&type=script&lang=js"
import style0 from "./TrainingMaterials.vue?vue&type=style&index=0&id=02328887&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02328887",
  null
  
)

export default component.exports